import React from 'react';

import Skeleton from '@atlaskit/avatar/skeleton';

const AvatarSkeletonCircleExample = (): React.JSX.Element => {
	return <Skeleton appearance="circle" />;
};

export default AvatarSkeletonCircleExample;
